// reveal.ts — progressive disclosure. Panels start with `.pre-reveal` (display:none) and drop in
// from the top with a gravity bounce when engagement happens (a mash button or a typed word). The
// reflow between un-hiding and adding `.drop-in` makes the CSS animation run from the visible state.

export function dropIn(el: HTMLElement, delayMs = 0): void {
  window.setTimeout(() => {
    el.classList.remove("pre-reveal");
    void el.offsetWidth; // force reflow so the drop animation plays from the now-shown state
    el.classList.add("drop-in");
  }, delayMs);
}

/** Like dropIn, but slams UP from the bottom (used for the rails). The rails use `pre-reveal-reserve`
 *  (invisible but KEPT in layout) rather than `pre-reveal` (removed), so the centre never shifts. */
export function slamUp(el: HTMLElement, delayMs = 0): void {
  window.setTimeout(() => {
    el.classList.remove("pre-reveal-reserve");
    void el.offsetWidth;
    el.classList.add("slam-up");
  }, delayMs);
}
